import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { ProcessModule, provideDefaultConfigFactory, StateConfig, StateTransferType } from '@spartacus/core';
import { CITY_FEATURE } from './city-state';
import { reducerProvider, reducerToken } from './reducers';

function cityStoreConfigFactory(): StateConfig {
  // if we want to reuse CITY_FEATURE const in config, we have to use factory instead of plain object
  return {
    state: {
      ssrTransfer: {
        keys: { [CITY_FEATURE]: StateTransferType.TRANSFER_STATE },
      },
    },
  };
}

@NgModule({
  imports: [ProcessModule.forRoot(), StoreModule.forFeature(CITY_FEATURE, reducerToken)],
  providers: [provideDefaultConfigFactory(cityStoreConfigFactory), reducerProvider],
})
export class CityStoreModule {}
